import fetch from 'isomorphic-fetch';
import { /*API_URL,*/ API2_URL, ROLES_REQUEST, ROLES_DELETE, ROLE_EDIT, ROLE_PERMISSIONS, ROLES_SHOW, ROLES_LIST, ROLES_COMPLETE, ROLES_CLEAR, ROLE_FAIL } from "../store/config";
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";

/*Roles Show*/
export const rolesShow = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(rolesRequest());
				return fetch((`${API2_URL}/roles?page=${page}`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(rolesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Roles List*/
export const fetchRolesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(rolesRequest());
				return fetch((`${API2_URL}/roles?order_by[field]=display&per_page=all`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(rolesListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Roles Edit*/
export const fetchRole = (id) => (dispatch) => {
	dispatch(rolesRequest());
	dispatch(rolesClear());
	return dispatch(roleEdit(id))
		.then((role) => {
			if(!_.isEmpty(role.payload)){
			 	return dispatch(rolesComplete());
			}else {
				return dispatch(rolesFail(role.error));
			}
		})

}

const roleEdit = (id) =>{
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/roles/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(roleEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Roles Save*/
export const roleSave = (values) => (dispatch) => {
	dispatch(rolesRequest());
	let permissions = [];

	_.mapKeys(values.permissions, (item) =>{
		return permissions.push(item.id);
	});

	if(!_.isEmpty(permissions)){
		return dispatch(roleEditSave(values))
			.then((role) => {
				if(!_.isEmpty(role.payload)){
					return dispatch(rolePermissionsEditSave(values, role.payload.id, permissions))
						.then((permission) => {
							if(!_.isEmpty(permission.payload)){
								return dispatch(rolesComplete());
							}else {
								return dispatch(rolesFail(permission.error));
							}
						})
				}else {
					return dispatch(rolesFail(role.error));
				}
			})
	}else {
		dispatch(newNotification({title: "¡Oh no!", content: "El perfil debe de contener mínimo un permiso", type: "danger"}))
		return dispatch(rolesFail("El perfil debe de contener mínimo un permiso"));
	}
}

const roleEditSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({id:values.id, display: values.display, agenciable_type: values.agenciable_type})
				};

				return fetch(`${API2_URL}/roles${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(roleEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Roles/Permissions Save*/
const rolePermissionsEditSave = (values, id, permissions) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({permissions})
				};

				return fetch(`${API2_URL}/roles/${id}/permissions${values.id ? `?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/perfiles/editar/${id}`);
							}
							return dispatch(permissionsRoleEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Roles Delete*/
export const roleDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'DELETE'
				};

				dispatch(rolesRequest());
				return fetch(`${API2_URL}/roles/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							dispatch(rolesShow())
							return dispatch(roleDeleteData(json))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(rolesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Fetching*/
const rolesRequest = () => {
	return {
		type: ROLES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const rolesData= (json) => {
	return {
		type: ROLES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	};
};

const rolesListData= (json) => {
	return {
		type: ROLES_LIST,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	};
};

const roleEditData = (json) => {
	let response = {};

	if(!_.isEmpty(json.data.permissions)){
		let permissions = [];
		_.mapKeys(json.data.permissions, (item) =>{
			return permissions.push({id: item})
		});

		response = {
			...json.data,
			permissions: permissions
		}
	}else {
		response = json.data
	}

	return {
		type: ROLE_EDIT,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const permissionsRoleEditData = (json) => {
	/*let permissions = [];
	_.mapKeys(json.data, (item) =>{permissions[item.id]=item.id});*/

	return {
		type: ROLE_PERMISSIONS,
		payload: json.data,
		timestamp: Date.now()
	}
}

const roleDeleteData = (json) => {
	return {
		type:ROLES_DELETE,
		isFetching: false,
		payload:json,
		timestamp:Date.now()
	}
};

const rolesComplete = () => {
	return {
		type: ROLES_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const rolesClear = () => {
	return {
		type: ROLES_CLEAR,
		payload: {
			permissions: []
		},
		permissions:[],
		timestamp: Date.now()
	}
}

/*Fails*/
const rolesFail = (error) => {
	return {
		type: ROLE_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/roles.js